export function QueueListCardSkeleton() {
  return (
    <article className="animate-pulse rounded-[8px] bg-[#eeeeee] p-[12px]">
      {/* Brand Panel skeleton */}
      <div className="flex h-[104px] flex-col items-center justify-center rounded-[7px] bg-[#d9d9d9]">
        <div className="h-[40px] w-[120px] rounded-[6px] bg-[#c4c4c4]" />
        <div className="mt-[12px] h-[12px] w-[90px] rounded-full bg-[#c4c4c4]" />
      </div>

      {/* Contador skeleton */}
      <div className="mt-[14px] flex flex-col items-center gap-[6px]">
        <div className="h-[48px] w-[110px] rounded-[8px] bg-[#d9d9d9]" />
        <div className="h-[12px] w-[150px] rounded-full bg-[#d9d9d9]" />
      </div>

      {/* Barra de progresso skeleton */}
      <div className="mx-[4px] mt-[14px] h-[12px] rounded-full bg-[#d9d9d9]" />

      {/* Status pill skeleton */}
      <div className="mt-[10px] flex min-h-[34px] items-center gap-[8px] rounded-full bg-[#d9d9d9] px-[10px] py-[6px]">
        <div className="h-[24px] w-[24px] shrink-0 rounded-full bg-[#c4c4c4]" />
        <div className="flex-1 space-y-[4px]">
          <div className="h-[8px] w-[60%] rounded bg-[#c4c4c4]" />
          <div className="h-[8px] w-[85%] rounded bg-[#c4c4c4]" />
        </div>
      </div>

      {/* Cancelar skeleton */}
      <div className="mt-[10px] flex justify-center pb-[2px]">
        <div className="h-[12px] w-[55px] rounded bg-[#d9d9d9]" />
      </div>
    </article>
  );
}
